module.exports = __webpack_public_path__ + "img/minima.9d25ba35.png";